
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get } from 'lodash';
import InContextNavigationTheme from '../pages/in-context/SidebarNavigation';
import NavigationTheme from '../pages/theme/NavigationTheme';

const themeSidebarHelper = Component => {
    class ThemeSidebar extends React.Component {
        render() {
            const { isThemeSbem } = this.props;
            return (
                <div>
                    {isThemeSbem ? (
                        <InContextNavigationTheme {...this.props} />
                    ) : (
                        <NavigationTheme {...this.props} />
                    )}
                </div>
            );
        }
    }

    ThemeSidebar.propTypes = {
        isThemeSbem: PropTypes.bool.isRequired
    };

    const mapStateToProps = state => ({
        code: get(state, 'app.selected.code'),
        themeList: get(state, 'app.selected.themeList', []),
        isThemeSbem: state.app.selected.isThemeSbem
    });

    return connect(mapStateToProps)(withRouter(ThemeSidebar));
};

export default themeSidebarHelper;



// WEBPACK FOOTER //
// ./src/components/helpers/sidebarHelper.js